<template>
<div :class="['lnb-nav', $style.h100]" v-loading="loading">
  <!-- 검색 영역 -->
  <div class="search">
    <w-search-field @search="filterTree"/>
  </div>
  <!-- 검색 영역 끝 -->
  <article :class="['category-item', $style['tree-h']]">
    <el-scrollbar class="tree-wrapper topologymap-tree" style="padding-top: 20px;">
      <el-tree
      :class="['obj-tree', 'map-tree', 'tree-w-stroke', $style.tree, isTreeEditMode ? 'tree-editor' : '']"
      style="height:100%;"
      ref="mapTree"
      :data="treeData"
      :props="treeProps"
      :node-key="treeProps.treeKey"
      :expand-on-click-node="false"
      :filter-node-method="filterNode"
      highlight-current
      :draggable="isTreeEditMode && isSettingAuth"
      @node-drop="handleNodeDrop"
      >
        <span class="el-tree-node__label" slot-scope="{ node, data }">
          <span v-if="!isTreeEditMode" @click="clickNode($event, node, data)">
            <span class="obj-icon">
              <i :class="data.isAutomap ? 'fas fa-chart-network' : 'fas fa-sitemap'"></i>
            </span>
            <span>{{data.label}}</span>
            <!-- <el-popover placement="right" trigger="hover" @show="showMapPreview(node)" :open-delay="1000" :visible-arrow="false" :popper-class="$style['preview-popup']">
              <div :class="$style['preview-wrapper']">
                <span v-if="previewLoading" :class="$style['no-preview']">미리보기 로드 중</span>
                <span v-else-if="!previewImgSrc" :class="$style['no-preview']">미리보기 없음</span>
                <img v-else :src="previewImgSrc" :class="$style['preview-img']"/>
              </div>
              <div slot="reference" class="preview-ref">
                <i class=""></i>
              </div>
            </el-popover> -->
          </span>
          <span v-else-if="isTreeEditMode && isSettingAuth">
            <el-tooltip content="하위맵 추가" placement="top">
              <span :class="['tree-node-edit-icon', (data.parentMapId !== -1) ? 'mini' : '']" style="margin-right:-1px;" @click="onSubMapAddBtn($event, node, data)">
                <i :class="[(data.parentMapId !== -1) ? 'far' : 'fas', 'fa-plus-circle']"></i>
              </span>
            </el-tooltip>
            <el-tooltip content="맵 삭제" placement="top">
              <span :class="['tree-node-edit-icon', (data.parentMapId !== -1) ? 'mini' : '']" style="margin-right:4px;" @click="onMapDeleteBtnClick($event, node, data)">
                <i :class="[(data.parentMapId !== -1) ? 'far' : 'fas', 'fa-minus-circle']"></i>
              </span>
            </el-tooltip>
            <span class="obj-icon" style="margin-left: 0px;">
              <i :class="data.isAutomap ? 'fas fa-chart-network' : 'fas fa-sitemap'"></i>
            </span>
            <span @click="clickNode($event, node, data)">{{data.label}}</span>
          </span>
          <span v-else-if="isTreeEditMode && !isSettingAuth">
            <span><el-checkbox v-model="data.hideFlag"></el-checkbox></span>
            <span>{{data.label}}</span>
          </span>
          <span v-else>
            <span>{{data.label}}</span>
          </span>
        </span>
      </el-tree>
    </el-scrollbar>
  </article>
</div>
</template>

<script>
import clone from 'lodash/clone';

import MapAPI from '@/api/topologymap/common';

import MapConst from '@/constants/topologymap';

import { getPathNodes, getPathNodeDatas } from '@/utils/tree';

import WSearchField from '@/components/form/SearchField';

import msgUtil from '@/utils/message';
import Base from '@/mixins/topologymap/base';

export default {
  name: 'WMapTree',
  components: {
    WSearchField,
  },
  mixins: [Base],
  data() {
    return {
      loading: false,
      // keyword: null,
      treeData: null,
      isEdit: false,
      previewImgSrc: null,
      previewLoading: false,
      treeProps: {
        treeKey: 'treeKey',
        children: 'children',
        label: 'label',
      },
    };
  },
  watch: {
    isTreeEditMode(value) {
      if (value === true) {
        this.filterTree();
      }
    },
  },
  computed: {
    viewMode() {
      return this.$store.getters.getTopologymapViewMode;
    },
  },
  created() {
    // 트리 갱신 이벤트 리스너
    this.$mapEventBus.$on(MapConst.MAP_EVENTBUS.TREE_LOAD, this.loadData);
    this.$mapEventBus.$on(MapConst.MAP_EVENTBUS.TREE_SELECT_NODE, this.selectNode);
    this.$mapEventBus.$on(MapConst.MAP_EVENTBUS.CHANGE_MAP_NAME, this.changeMapName);
    this.loadData();
  },
  beforeDestroy() {
    this.$mapEventBus.$off(MapConst.MAP_EVENTBUS.TREE_LOAD, this.loadData);
    this.$mapEventBus.$off(MapConst.MAP_EVENTBUS.TREE_SELECT_NODE, this.selectNode);
  },
  // watch: {
  //   keyword(value) {
  //     this.$refs.mapTree.filter(value);
  //   },
  // },
  methods: {
    /**
     * 맵 이름 수정 버튼 클릭
     * @author KangBonghun(toto1323)
     * @param  {Object} data 노드 데이터
     */
    onMapLabelEditClick(data) {
      const panel = this.getTopologymapPanel();

      if (panel) {
        panel.$refs.mapLabelEditPopup.open({
          model: data,
        });
      }
    },
    /**
     * 노드 클릭
     * @author KangBonghun(toto1323)
     * @param  {[type]} nodeData [description]
     */
    clickNode(evt, node, nodeData) {
      evt.stopPropagation();
      if (this.isTreeEditMode) {
        this.onMapLabelEditClick(nodeData);
      } else if (!this.isTreeEditMode) {
        if (!nodeData.auth) {
          this.$message.info('접근 권한이 없습니다');
        } else {
          this.$router.push({
            path: `/topologymap/${nodeData.treeKey}`,
            params: {
              treeKey: nodeData.treeKey,
            },
          });
        }
      }
    },
    /**
     * 노드 필터링
     * @author KangBonghun(toto1323)
     * @param  {[type]} value [description]
     * @param  {[type]} data  [description]
     * @return {[type]}       [description]
     */
    filterNode(value, data) {
      if (!this.isTreeEditMode && data.hideFlag) return false;
      if (!value) return true;
      return data.label.toLowerCase().indexOf(value.toLowerCase()) !== -1;
    },
    filterTree(value) {
      this.$refs.mapTree.filter(value);
    },
    /**
     * 트리 리로드
     * @author KangBonghun(toto1323)
     */
    loadData() {
      this.loading = true; // 로딩 표시

      MapAPI.getTopologymapTree().then((response) => {
        this.loading = false; // 로딩 숨김

        this.treeData = response.data.children;

        this.$nextTick(() => {
          // 1depth까지는 expand 시킨다.
          this.$refs.mapTree.root.childNodes.forEach((node) => {
            node.expanded = true;
          });
          // 숨길 맵은 필터링
          this.filterTree();
        });

        this.selectNode(this.$route.params.treeKey);

        this.$emit('loadComplete');
      });
    },
    selectNode(treeKey) {
      this.$nextTick(() => {
        const node = this.$refs.mapTree.getNode(treeKey);

        // 트리 노드 선택 및 확장
        this.$refs.mapTree.setCurrentKey(treeKey);
        const path = getPathNodes(node);
        path.forEach((item) => {
          if (!item.isLeaf) {
            item.expanded = true;
          }
        });

        // store 설정
        let nodeData;
        let nodePath;
        if (!node) {
          nodeData = null;
        } else {
          nodeData = clone(node.data);
          nodePath = clone(getPathNodeDatas(node));
          if (nodeData.type === 'obj' && node.parent.data.type === 'group') {
            nodeData.parent = node.parent.data;
          }
        }
        this.$store.dispatch('setSelectedNode', nodeData);
        this.$store.dispatch('setSelectedNodePath', nodePath);

        if (this.$store.state.common.activeTab) {
          this.$store.dispatch('setActiveTab', null);
        }

        // 라우터 path 동기화
        const objId = this.$route.query.objId || this.$route.params.objId;
        console.debug(objId);
        this.$router.replace({
          path: `/topologymap/${treeKey}`,
          params: {
            treeKey,
          },
          query: {
            objId,
          },
        });
      });
    },
    /**
     * 맵 미리보기 이미지를 보여준다.
     * @author KangBonghun(toto1323)
     * @param  {[type]} mouseoverNode [description]
     * @return {[type]}               [description]
     */
    showMapPreview(mouseoverNode) {
      this.previewLoading = true;
      this.previewImgSrc = null;

      MapAPI.getMapPreview(mouseoverNode.data.mapId).then((response) => {
        const result = response.data;

        if (result.success && result.data) {
          this.previewImgSrc = `data:image/png;base64,${result.data}`;
        }

        this.previewLoading = false;
      });
    },
    /**
     * 토폴로지맵 패널을 찾는다.
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    getTopologymapPanel() {
      let parent = this.$parent;

      do {
        if (parent) {
          if (parent.$refs.topologymapPanel) {
            return parent.$refs.topologymapPanel;
          }
          parent = parent.$parent;
        }
      } while (parent);

      return null;
    },
    handleNodeDrop(draggingNode, droppedNode, dropType) {
      if (dropType && dropType === 'inner') {
        draggingNode.data.parentMapId = droppedNode.data.mapId;
        draggingNode.data.mapRoot = '0';
      } else if (dropType === 'after' || dropType === 'before') {
        if (droppedNode.data.mapRoot === '1') { // 최상위 맵의 근처로 정렬 되었을 때
          draggingNode.data.parentMapId = -1;
          draggingNode.data.mapRoot = '1';
        } else { // 하위맵의 근처로 정렬 되었을 때
          draggingNode.data.parentMapId = droppedNode.data.parentMapId;
          draggingNode.data.mapRoot = '0';
        }
      }

      this.updateMapTreeOrder();
    },
    changeMapName(name) {
      const node = this.$refs.mapTree.getCurrentNode();
      node.label = name;
    },
    /**
     * 하위맵 추가 버튼 클릭
     * @author KangBonghun(toto1323)
     */
    onSubMapAddBtn(evt, node, data) {
      evt.stopPropagation();
      const panel = this.getTopologymapPanel();

      if (panel) {
        panel.$refs.mapPropertyPopup.open({
          type: 'ADD_SUB',
          data,
        });
      }
    },
    /**
     * 맵 삭제 버튼 클릭
     * @author KangBonghun(toto1323)
     */
    onMapDeleteBtnClick(evt, node, data) {
      evt.stopPropagation();

      /* eslint-disable  */
      // 하위에 연결관계 맵 존재 여부 확인
      MapAPI.checkIncludeAutomap(data.mapId).then((response) => {
        const result = response.data;

        if (result.success) {
          if (result.data === true) { // 존재
            this.isDeleteAllMap = false;

            const messageRenderer = (
              <div>
              {(<div style="margin-bottom:5px;">맵을 삭제하시겠습니까?</div>)}
              {(<el-checkbox checked={ this.isDeleteAllMap } onChange={ (value) => { this.isDeleteAllMap = value; } }>연결관계 맵 포함</el-checkbox>)}
              {<div class="map-delete-note mr">*연결관계 수집 스케줄도 함께 삭제됩니다.</div>}
              </div>
            );

            this.$msgbox({
              title: '확인',
              message: messageRenderer,
              showCancelButton: true,
              ...msgUtil.defaultConfirmButton,
              customClass: 'confirm-box',
            }).then(() => {
              this.deleteMap(data.mapId, this.isDeleteAllMap);
            }).finally(() => {
              this.isDeleteAllMap = false;
            });
          } else { // 미존재
            if (data.isAutomap) {
              const messageRenderer = (
                <div>
                {(<div style="margin-bottom:5px;">맵을 삭제하시겠습니까?</div>)}
                {<div class="map-delete-note">*연결관계 수집 스케줄도 함께 삭제됩니다.</div>}
                </div>
              );

              this.$msgbox({
                title: '확인',
                message: messageRenderer,
                showCancelButton: true,
                ...msgUtil.defaultConfirmButton,
                customClass: 'confirm-box',
              }).then(() => {
                this.deleteMap(data.mapId, true);
              }).finally(() => {
              });
            } else {
              this.$confirm(...msgUtil.getBasicConfirmData('맵을 삭제'))
              .then(() => {
                this.deleteMap(data.mapId);
              })
              .catch(() => {});
            }
          }
        }
      });

      /* eslint-enable  */
    },
    deleteMap(mapId, includeAutomap) {
      MapAPI.deleteTopologymap(mapId, includeAutomap).then((response) => {
        const result = response.data;

        if (result.success) {
          this.$message.success('맵을 삭제하였습니다.');
          // 맵 트리 리로드
          this.treeLoad();
        } else {
          this.$message.error('맵을 삭제하지 못하였습니다.');
        }
      });
    },
    getTreeData() {
      return this.treeData;
    },
    updateMapTreeOrder() {
      this.loading = true;
      const param = this.recursiveFunctionForTreeData(this.getTreeData());
      MapAPI.updateTopologymapTreeOrder(param).then((response) => {
        if (response.data && response.data.success) {
          this.loading = false;
          this.$message.success('맵 정렬을 저장하였습니다.');
        } else {
          this.$message.error('맵 정렬을 저장하지 못하였습니다.');
        }
      });
    },
    updateMapTreeShow() {
      this.loading = true;
      const param = this.recursiveFunctionForTreeData(this.getTreeData());
      MapAPI.updateTopologymapTreeHide(param).then((response) => {
        if (response.data && response.data.success) {
          this.loading = false;
          this.$message.success('맵 트리 표현을 저장하였습니다.');
        } else {
          this.$message.error('맵 트리 표현을 저장하지 못하였습니다.');
        }
      });
    },
    recursiveFunctionForTreeData(treeData) {
      const result = [];
      let orderbyIndex = 0;
      function recursiveFunction(data) {
        if (data && data.mapId) {
          // result.push({
          //   mapId: data.mapId,
          //   orderbyIndex: orderbyIndex += 1,
          //   parentMapId: data.parentMapId,
          //   mapRoot: data.mapRoot,
          //   hideFlag: data.hideFlag,
          // });
          orderbyIndex += 1;
          data.orderbyIndex = orderbyIndex;
          result.push(data);
        }
        if (Array.isArray(data)) {
          data.forEach(recursiveFunction);
          return;
        }
        if (typeof data === 'object' && data.children && data.children.length > 0) {
          recursiveFunction(data.children);
        }
      }
      recursiveFunction(treeData);
      return result;
    },
    allCheck(hideFlag) {
      const nodeList = this.recursiveFunctionForTreeData(this.getTreeData());
      nodeList.forEach((node) => {
        node.hideFlag = hideFlag;
      });
    },
  },
};
</script>

<style lang="scss">
.map-tree {
  .el-tree-node__label {
    padding-left: 4px;
  }
  // 최상위 맵일 경우 자식이 없으면 expand 아이콘을 숨긴다.
  .el-tree-node__content .is-leaf.el-tree-node__expand-icon {
    display: none;
  }
  .obj-icon {
    margin: 0px 0px 0 -4px;
    color: #777 !important;
  }
}
.tree-editor {
  .el-tree-node__label {
    padding-left: 0px;
  }
}
.map-delete-note {
  color: #2342c8;
  font-size: .75rem;
  margin-top: -5px;
  &.mr {
    margin-left: 20px;
  }
}
</style>
<style module>
.h100 {
  height: 100%;
}
.tree-h {
  padding: 0 0 0 20px !important;
  height: calc(100% - 36px) !important;
}
.preview-popup {
  width: 250px;
  height: 150px;
  background: rgba(208,213,223,0.8);
  border-radius: 3px;
  padding: 7px;
  display: table;
}
.preview-wrapper {
  width: 100%;
  height: 100%;
  border: solid 1px #bdc2cc;
  border-bottom: solid 1px #abafb8;
  display: flex;
}
.preview-img {
  width: 250px;
  height: 150px;
}
.no-preview {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  color: #434d6b;
  font-weight: 500;
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// src/views/topologymap/components/MapTree.vue